// extracted by mini-css-extract-plugin
export default {"geniumSolution":"Brandmark_geniumSolution__CKjI6"};